'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { SegmentButton } from '@components/Button';
import { TabWrapper } from '@components/Shifts/components/styles/ScrollableMenu';
import { DEFAULT_TAB, ShiftTab, TABS } from '@components/Shifts/interfaces';

interface ScrollableMenuProps {
  activeTab: ShiftTab;
  onTabClick: (tab: ShiftTab) => void;
}

/**
 * Scrollable menu component that displays the tabs for the shifts page
 * for different shifts stages
 */
export const ScrollableMenu: React.FC<ScrollableMenuProps> = ({ activeTab, onTabClick }) => {
  const { t } = useTranslation('common');

  return (
    <TabWrapper>
      {TABS.map((tab) => (
        <SegmentButton
          key={tab}
          label={t(tab === DEFAULT_TAB ? 'menu.notifications' : tab)}
          active={activeTab === tab}
          onClick={() => onTabClick(tab)}
        />
      ))}
    </TabWrapper>
  );
};
